import { Controller, useFormContext } from 'react-hook-form';
import { TextArea } from '@common/components/FormElements/Textarea';

interface NotesFieldProps {
  name: string;
  label: string;
  id?: string;
}

/**
 * Reusable notes field component that wraps TextArea with Controller.
 * Provides consistent styling and behavior for notes/comments inputs across the wizard.
 *
 * @param name - The form field name to bind to
 * @param label - The label text to display
 * @param id - Optional HTML id attribute
 */
export const NotesField: React.FC<NotesFieldProps> = ({ name, label, id = 'additional-notes' }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => (
        <TextArea
          isFullWidth
          labelWidth="150px"
          name="note"
          label={label}
          id={id}
          onChange={(val) => {
            if (val) {
              onChange(val);
            }
          }}
          input={{
            value,
          }}
          error={''}
        />
      )}
    />
  );
};
